/**
 * Quote a property name in the concrete syntax so that it will parse back to the same property name.
 * @param propertyName the property name to quote
 * @returns the quoted property name
 */
export function quote(propertyName: string) {
    return `"${propertyName.replace(/"/g, '\\"')}"`;
}
